import React from 'react';
import JSPDF from 'jspdf';
import { renderToString } from 'react-dom/server';
import moment from 'moment';
import Logo from '../../../assets/images/new_logo1.png';
import './styles.css';

interface Stores {
    name: string;
}

interface Props {
    products: any;
    data: Stores;
}

interface PlanogramList {
    product_name: string;
    bar_code: string;
    standard_amount: number;
    stock_amount: number;
    amount_to_transfer: number;
}

const TemplatePicklist: React.FC<Props> = ({ products, data }) => {
    const students = [
        'Nome do Produto',
        'Código de Barras Primário',
        'Qtd. Padrão Destino',
        'Qtd. Estoque Destino',
        'Qtd. à Transferir',
        'Qtd. Final',
    ];

    const renderTableHeader = () => {
        return students.map((key, index) => {
            return <th key={index}>{key}</th>;
        });
    };

    const renderTableData = () => {
        return products.map((planogram: PlanogramList, index: number) => {
            const {
                product_name,
                bar_code,
                standard_amount,
                stock_amount,
                amount_to_transfer,
            } = planogram;
            return (
                <tr key={index}>
                    <td>{product_name}</td>
                    <td>{bar_code || 'Não informado'}</td>
                    <td>
                        {typeof standard_amount === 'number'
                            ? standard_amount
                            : 'Não informado'}
                    </td>
                    <td>
                        {typeof stock_amount === 'number'
                            ? stock_amount
                            : 'Não informado'}
                    </td>
                    <td>
                        {typeof amount_to_transfer === 'number'
                            ? amount_to_transfer
                            : 'Não informado'}
                    </td>
                    <td />
                </tr>
            );
        });
    };

    return (
        <div>
            <div id="containerImage">
                <img id="image" src={Logo} alt="icon" />
                <h1 id="title">PLANOGRAMAS</h1>
            </div>

            <div id="divider" />
            <div id="headerPrincipal">
                <h1>Data: {moment().format('DD/MM/YYYY HH:mm:ss')}</h1>
                <h1>Lojas: {data.name.toUpperCase()}</h1>
            </div>
            <div id="divider" />
            <table id="picklist">
                <tbody>
                    {renderTableHeader()}
                    {renderTableData()}
                </tbody>
            </table>
        </div>
    );
};

export const print = (products: PlanogramList[], data: Stores) => {
    const string = renderToString(
        <TemplatePicklist products={products} data={data} />,
    );
    const pdf = new JSPDF('p', 'px');

    pdf.html(string, {
        width: 400,
        callback: (e) =>
            e.save(`PLANOGRAMA_${moment().format('DD-MM-YYYY')}.pdf`),
        windowWidth: 650,
        autoPaging: 'text',
        x: 25,
        margin: [20, 0, 20, 0],
        image: {
            quality: 1,
            type: 'jpeg',
        },
    });
};

export default TemplatePicklist;
